<template>
<div>
    <div :style="{ fontSize: fontSize + 'px' }"><span class="font-weight-bold">{{ units }}</span><sup>{{ cents }}</sup> <span class="currency">{{ currency }}</span></div>
</div>
</template>

<script>
export default {
    props: {
        price: {
            type: [String, Number],
            default: 0
        },
        currency: {
            type: String,
            default: 'RON'
        },
        fontSize: {
            type: String,
            default: "14"
        },
        decimals: {
            type: Number,
            default: 2
        }
    },
    computed: {
        units() {
            if(this.price === 0 || this.price === null || this.price === "0") {
                return 0
            }
            return this.price.toString()
                .split('.')[0];
        },
        cents() {
            if(this.price === 0 || this.price === null) {
                return
            }
            let cents = this.price.toString()
                .split('.')[1];
            if(cents) {
                let rounding = cents.substring(0, this.decimals);
                if(rounding.length > 1) {
                    return rounding;
                } else {
                    return rounding + '0';
                }
            } else {
                return '00';
            }
        }
    },
}
</script>

<style>
.currency {
    font-weight: 300;
}
</style>
